import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  archivedCrops: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.ARCHIVED_CROPS_SUCCESS:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.ARCHIVED_CROPS:
          return Object.assign({}, state, {isArchivedCropLoading: true});
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.ARCHIVED_CROPS:
          return Object.assign({}, state, {isArchivedCropLoading: false});
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
